<template>
  <div id="uploadFile">
    <pt-modal :title="$t('deal.dealDetails.dealDetail.uploadFile')"  :visible="visible" :width="800"  @cancel="hide" @ok="submit" :loading="loading">
      <div slot="content">
        <div>
          <a-row>
            <pt-oss-upload inconType="icon-shangchuan" @onSuccess="onSuccess" style="float:right;" id="dealDetailsUpload"></pt-oss-upload>
          </a-row>
          <a-row v-if="filesTobeUpload.length == 0" class="upload_file_empty">
            <pt-oss-upload @onSuccess="onSuccess" >
              <div>
                <pt-empty></pt-empty>
              </div>
            </pt-oss-upload>
          </a-row>
          <a-row v-else>
            <a-row v-for="(file,index) in filesTobeUpload" :key="file.id" class="fileRowClass">
              <div class="deal_files" :style="index == 0 ? {marginTop: '24px'} : {}">
                <div style="margin-right: 20px;">
                  <pt-icon type="icon-fujian" :styleObj="{fontSize: '22px'}"></pt-icon>
                </div>
                <div style="flex: 1;font-size: 12px;color: #333333;display: flex; align-items: center;">{{file.name}}</div>
                <div style="display: flex;align-items: center;">
                  <div @click="removeFile(file,index)">
                    <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}"></pt-icon>
                  </div>
                </div>
              </div>
            </a-row>
          </a-row>
        </div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  import dealFilesApi from '@/api/mine/dealFiles'
  import pursuitsFilesApi from '@/api/mine/pursuitsFiles'

  export default {
    name: 'uploadFile',
    props: {
      dealId:{
        type:String,
        default:null
      },
      pursuitsId:{
        type:String,
        default:null
      },
      leaseId:{
        type:String,
        default:null
      },
      visible:{
        type:Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        filesTobeUpload:[],
      }
    },
    mounted() {

    },
    methods: {
      hide(){
        this.$emit('cancel')
      },
      onSuccess(file,fileId,number){
        this.filesTobeUpload.push(Object.assign(file,{id:fileId}))
      },
      removeFile(file,index){
        this.filesTobeUpload.splice(index,1)
      },
      submit(){
        let this_ = this
        if(this.filesTobeUpload.length == 0){
          this.$message.error(this.$t('deal.upload.errorInfo.empty'))
          return
        }
        if(this.dealId){
          let dealFiles = this.filesTobeUpload.map(f => {
            return {dealId: this.dealId, fileId: f.id}
          })
          this.loading = true
          dealFilesApi.batchInsertDealFiles(dealFiles).then(res=>{
            if(res.code == 1){
              this_.$message.success(res.message)
              this_.filesTobeUpload = []
              this.$emit('onSuccess')
            }else{
              this_.$message.error(res.message)
            }
            this.loading = false
          })
        }else if(this.pursuitsId){
          let pursuitsFiles = this.filesTobeUpload.map(f => {
            return {pursuitsId: this.pursuitsId, fileId: f.id}
          })
          this.loading = true
          pursuitsFilesApi.batchInsertPursuitsFiles(pursuitsFiles).then(res=>{
            if(res.code == 1){
              this_.$message.success(res.message)
              this_.filesTobeUpload = []
              this.$emit('onSuccess')
            }else{
              this_.$message.error(res.message)
            }
            this.loading = false
          })
        }else{

        }
      }
    }
  }
</script>

<style scoped lang="less">
    .fileRowClass{
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
    }
    .fileRowClass:last-child{
      border-bottom: 0;
    }
    .upload_file_empty{
      margin-top: 10px;
      display: flex;
      height: 250px;
      justify-content: center;
      align-items: center;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .deal_files{
      display: flex;
    }
</style>